import { nextTick, computed } from "vue";
import store from '@shared/store/index';
import { useRoute } from 'vue-router';
import DROPDOWN_NAMES from "@shared/constants/dropdowns/dropdownsName";

/**
 * Пост, связанный с активным плеером (вычисляемое свойство)
 */
const postWithActivePlayer = computed(() => {
  const postCtx = store.state.ContentSystem.Alpha;
  const podcastCtx = store.state.Audioplayer;
  return postCtx.list[podcastCtx.list[podcastCtx.activePodcastId].object_id];
});

/**
 * Управление контентными попапами
 */
export function useContentPopup() {
  const route = useRoute();

  /**
   * Открывает попап для поста
   * @param {string|number} postId
   * @param {boolean} [replaceState=true]
   */
  const openContentPopup = async (postId, replaceState = true) => {  
    store.dispatch('Dropdowns/removeTheDropdown', DROPDOWN_NAMES.contentPage);
    await nextTick();
    store.commit('ContentSystem/toRememberLastPageUrl', route.path);
    if (replaceState) {
      window.history.pushState({}, '', window.location.href);
      window.history.replaceState({}, '', `/news/${postId}`);
    }
    store.dispatch('Dropdowns/addNewDropdown', DROPDOWN_NAMES.contentPage);
  };

  return {
    openContentPopup,
    postWithActivePlayer
  };
}